module.exports = __webpack_public_path__ + "static/product-features-1d20ad906989e2f5aa06f11b81b39237.png";